const formatStudentGrades = (results) =>
  results.reduce((allGrades, result) => {
    // it can be null, if assessment item has no mapping
    if (!result) {
      return allGrades;
    }

    return {
      ...allGrades,
      [result.assessmentItemId]: {
        ...result.studentGrade,
      },
    };
  }, {});

export default formatStudentGrades;
